import { ApolloClient, gql, NormalizedCacheObject, useQuery } from '@apollo/client'
import { VisibleProductDropsQuery, VisibleProductDropsQueryVariables } from 'types/graphql'
import { productDropFragment } from './productDropFragment'

const query = gql`
  ${productDropFragment}

  query VisibleProductDrops {
    productDrops(filter: Visible, isPromoted: true) {
      ...ProductDropFields
    }
  }
`

export const useVisibleProductDrops = () => {
  return useQuery<VisibleProductDropsQuery, VisibleProductDropsQueryVariables>(query)
}

export const preloadVisibleProductDrops = ({ apolloClient }: { apolloClient: ApolloClient<NormalizedCacheObject> }) => {
  return apolloClient.query<VisibleProductDropsQuery, VisibleProductDropsQueryVariables>({ query })
}
